<div *ngIf="variedadObs$ | async as resp">
  <app-detail-view
    [design]="'row_a'"
    [type]="'detail_information'"
    [data]="{
      data_1: resp.data.group_X,
      data_2: resp.data.group_Z,
      data_3: resp.data.group_Y,
      data_4: resp.data.group_A,

      data_5: resp.data.last_observation,
      data_6: resp.data.first_observer,
      data_7: resp.data.public_observation_count
    }"
    [images]="resp.data.images"
    [background_color]="'#ffeffa'"
    [myAngularxQrCode]="myAngularxQrCode"
  ></app-detail-view>
</div>

<div *ngIf="variedadObs$ | async as resp">
  <div *ngIf="gpsObs$ | async as gps">
    <app-detail-view
      [design]="'row_b'"
      [type]="'values_uses_information'"
      [data]="{
        data_1: resp.data.group_C,
        data_2: resp.data.descriptors_agronomy,
        data_3: resp.data.descriptors_culinary,
        data_4: resp.data.descriptors_post_harvest,
        data_5: gps.data
      }"
      [background_color]="'#fff'"
    ></app-detail-view>
  </div>
</div>

<div *ngIf="variedadObs$ | async as resp">
  <app-detail-view
    [design]="'row_c'"
    [type]="'descriptors_plant'"
    [data]="resp.data.descriptors_plant"
    [images]="resp.data.images"
    [background_color]="'#e5dbe5'"
  ></app-detail-view>
</div>

<div *ngIf="variedadObs$ | async as resp">
  <app-detail-view
    [design]="'row_c'"
    [type]="'descriptors_flower'"
    [data]="resp.data.descriptors_flower"
    [images]="resp.data.images"
    [background_color]="'#e5dbe5'"
  ></app-detail-view>
</div>

<div *ngIf="variedadObs$ | async as resp">
  <app-detail-view
    [design]="'row_c'"
    [type]="'descriptors_tuber'"
    [data]="resp.data.descriptors_tuber"
    [images]="resp.data.images"
    [background_color]="'#e5dbe5'"
  ></app-detail-view>
</div>

<div *ngIf="variedadObs$ | async as resp">
  <app-detail-view
    [design]="'row_c'"
    [type]="'descriptors_agronomy'"
    [data]="resp.data.descriptors_agronomy"
    [images]="resp.data.images"
    [background_color]="'#ffe7e5'"
  ></app-detail-view>
</div>
